import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Detail from "./Detail.js"
import Delete from "./Delete.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class Grupos extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "pk",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Abreviatura",
                    id: "abreviatura",
                    accessor: d => d.abreviatura,
                    show: true,
                },
                {
                    Header: "Teléfono",
                    id: "telefono",
                    accessor: d => d.telefono,
                    show: true,
                },
                {
                    Header: "Email",
                    id: "mail",
                    accessor: d => d.mail,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        component: Create,
                        permission: 'grupos_add',
                    },
                    {
                        detail: true,
                        component: Detail,
                        permission: 'grupos_detail',
                    },
                    {
                        edit:true,
                        component: Edit,
                        permission: 'grupos_edit',
                    },
                    {
                        edit:true,
                        component: Delete,
                        permission: 'grupos_delete',
                    }
                ]}
                apiUrl={api.usuarios.grupos.list}
                columns={this.state.columns}
                exportUrl={api.usuarios.grupos.export}
                title={"Grupos"}
            />
        );
    }
}

export default Grupos;



// WEBPACK FOOTER //
// ./src/views/Usuarios/Grupos/Grupos.js